import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=25e76f61&scoped=true"
import script from "./MessageIndex.vue?vue&type=script&lang=js"
export * from "./MessageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e76f61",
  null
  
)

export default component.exports